var Chaplin, FOOTNOTE_SYMBOLS, numberToSymbol, objectsEqual, sanitizeHTML, utils, _curryN,
  __hasProp = {}.hasOwnProperty,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
  __slice = [].slice;

Chaplin = require('chaplin');

sanitizeHTML = function(value) {
  return value.replace(/<\/?[^>]+(>|$)/g, '');
};

FOOTNOTE_SYMBOLS = ['*', '†', '‡', '§', '||', '¶'];

objectsEqual = function(objA, objB, seenObjects) {
  var aKey, aVal, bKey, bVal, keyValuesAreSame;
  if (seenObjects == null) {
    seenObjects = new Set();
  }
  seenObjects.add(objA);
  seenObjects.add(objB);
  if (objA === objB) {
    return true;
  }
  if ((objA == null) && (objB == null)) {
    return true;
  }
  if (!(_.isObject(objA) && _.isObject(objB))) {
    return objA === objB;
  }
  if ((objA == null) && objB || objA && (objB == null)) {
    return false;
  }
  for (aKey in objA) {
    aVal = objA[aKey];
    if (Object.hasOwnProperty.call(objA, aKey) && !Object.hasOwnProperty.call(objB, aKey)) {
      return false;
    }
    bVal = objB[aKey];
    if (seenObjects.has(aVal) || seenObjects.has(bVal)) {
      continue;
    }
    keyValuesAreSame = aVal === bVal ? true : Immutable.Iterable.isIterable(aVal) && Immutable.Iterable.isIterable(bVal) ? aVal.equals(bVal) : _.isObject(aVal) && _.isObject(bVal) ? objectsEqual(aVal, bVal, seenObjects) : false;
    if (!keyValuesAreSame) {
      return false;
    }
  }
  for (bKey in objB) {
    if (Object.hasOwnProperty.call(objB, bKey) && !Object.hasOwnProperty.call(objA, bKey)) {
      return false;
    }
  }
  return true;
};

utils = Chaplin.utils.beget(Chaplin.utils);

_(utils).extend({

  /*
  Wrap methods so they can be called before a deferred is resolved.
  The actual methods are called once the deferred is resolved.
  
  Parameters:
  
  Expects an options hash with the following properties:
  
  deferred
    The Deferred object to wait for.
  
  methods
    Either:
    - A string with a method name e.g. 'method'
    - An array of strings e.g. ['method1', 'method2']
    - An object with methods e.g. {method: -> alert('resolved!')}
  
  host (optional)
    If you pass an array of strings in the `methods` parameter the methods
    are fetched from this object. Defaults to `deferred`.
  
  target (optional)
    The target object the new wrapper methods are created at.
    Defaults to host if host is given, otherwise it defaults to deferred.
  
  onDeferral (optional)
    An additional callback function which is invoked when the method is called
    and the Deferred isn't resolved yet.
    After the method is registered as a done handler on the Deferred,
    this callback is invoked. This can be used to trigger the resolving
    of the Deferred.
  
  Examples:
  
  deferMethods(deferred: def, methods: 'foo')
    Wrap the method named foo of the given deferred def and
    postpone all calls until the deferred is resolved.
  
  deferMethods(deferred: def, methods: def.specialMethods)
    Read all methods from the hash def.specialMethods and
    create wrapped methods with the same names at def.
  
  deferMethods(
    deferred: def, methods: def.specialMethods, target: def.specialMethods
  )
    Read all methods from the object def.specialMethods and
    create wrapped methods at def.specialMethods,
    overwriting the existing ones.
  
  deferMethods(deferred: def, host: obj, methods: ['foo', 'bar'])
    Wrap the methods obj.foo and obj.bar so all calls to them are postponed
    until def is resolved. obj.foo and obj.bar are overwritten
    with their wrappers.
   */
  deferMethods: function(options) {
    var deferred, func, host, methods, methodsHash, name, onDeferral, target, _i, _len, _results;
    deferred = options.deferred;
    methods = options.methods;
    host = options.host || deferred;
    target = options.target || host;
    onDeferral = options.onDeferral;
    methodsHash = {};
    if (typeof methods === 'string') {
      methodsHash[methods] = host[methods];
    } else if (methods.length && methods[0]) {
      for (_i = 0, _len = methods.length; _i < _len; _i++) {
        name = methods[_i];
        func = host[name];
        if (typeof func !== 'function') {
          throw new TypeError("utils.deferMethods: method " + name + " not found on host " + host);
        }
        methodsHash[name] = func;
      }
    } else {
      methodsHash = methods;
    }
    _results = [];
    for (name in methodsHash) {
      if (!__hasProp.call(methodsHash, name)) continue;
      func = methodsHash[name];
      if (typeof func !== 'function') {
        continue;
      }
      _results.push(target[name] = utils.createDeferredFunction(deferred, func, target, onDeferral));
    }
    return _results;
  },
  createDeferredFunction: function(deferred, func, context, onDeferral) {
    if (context == null) {
      context = deferred;
    }
    return function() {
      var args;
      args = arguments;
      if (deferred.state() === 'resolved') {
        return func.apply(context, args);
      } else {
        deferred.done(function() {
          return func.apply(context, args);
        });
        if (typeof onDeferral === 'function') {
          return onDeferral.apply(context);
        }
      }
    };
  },
  isElementAttached: function(elem) {
    if (!elem) {
      return false;
    }
    return $.contains(document.body, elem.jquery ? elem[0] : elem);
  },
  hasValue: function(value) {
    return !(_.isNull(value) || _.isUndefined(value) || (_.isString(value) && _.string.trim(value) === ''));
  },
  toUnderscore: function(camelCaseString) {
    return camelCaseString.replace(/([A-Z])/g, function($1) {
      return "_" + $1.toLowerCase();
    });
  },
  dashToUnderscore: function(dashedString) {
    return dashedString.replace(/-/g, '_');
  },
  camelcaseToSentence: function(camelCaseString) {
    return camelCaseString.replace(/([A-Z])/g, function($1) {
      return " " + $1.toLowerCase();
    });
  },
  firstLetterToLowerCase: function(string) {
    return "" + (string.charAt(0).toLowerCase()) + (string.slice(1));
  },
  bracketize: function(str) {
    return "[" + str + "]";
  },
  uncapitalizeExceptAllCaps: function(str, allWords) {
    var allWordsStartsWithCaps, firstWord;
    if (allWords == null) {
      allWords = true;
    }
    if (allWords) {
      allWordsStartsWithCaps = _.string.words(str).every(function(word) {
        return word.toUpperCase().charAt(0) === word.charAt(0);
      });
      if (allWordsStartsWithCaps) {
        return str;
      }
    }
    firstWord = _.string.words(str)[0];
    if (firstWord.toUpperCase() === firstWord) {
      return str;
    } else {
      return str.charAt(0).toLowerCase() + str.slice(1);
    }
  },
  capitalizeFirstLetter: function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  cycleUp: function(currentValue, cycleLength) {
    if (currentValue === cycleLength - 1) {
      return 0;
    } else {
      return currentValue + 1;
    }
  },
  cycleDown: function(currentValue, cycleLength) {
    if (currentValue === 0) {
      return cycleLength - 1;
    } else {
      return currentValue - 1;
    }
  },
  getCaretPos: function(el) {
    var r, rc, re;
    if (el.selectionStart) {
      return el.selectionStart;
    } else if (document.selection) {
      el.focus();
      r = document.selection.createRange();
      if (r === null) {
        return 0;
      }
      re = el.createTextRange();
      rc = re.duplicate();
      re.moveToBookmark(r.getBookmark());
      rc.setEndPoint('EndToStart', re);
      return rc.text.length;
    }
    return 0;
  },
  getEventCoordinates: function(e) {
    var coord, posx, posy;
    if (e.pageX || e.pageY) {
      posx = e.pageX;
      posy = e.pageY;
    } else if (e.clientX || e.clientY) {
      posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
      posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }
    return coord = {
      left: posx,
      top: posy
    };
  },
  setSelectionRange: function(input, selectionStart, selectionEnd) {
    var range;
    if (input.setSelectionRange) {
      input.focus();
      return input.setSelectionRange(selectionStart, selectionEnd);
    } else if (input.createTextRange) {
      range = input.createTextRange();
      range.collapse(true);
      range.moveEnd('character', selectionEnd);
      range.moveStart('character', selectionStart);
      return range.select();
    }
  },
  setCaretToPos: function(input, pos) {
    return this.setSelectionRange(input, pos, pos);
  },
  generateGUID: function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r, v;
      r = Math.random() * 16 | 0;
      v = c === 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  },
  getNamedGUIDV3: function(name) {
    var md5Bytes;
    md5Bytes = Buffer.from(md5(name), 'hex');
    md5Bytes[6] &= 0x0F;
    md5Bytes[6] |= 0x30;
    md5Bytes[8] &= 0x3F;
    md5Bytes[8] |= 0x80;
    return uuid.stringify(md5Bytes);
  },
  uid: function(len) {
    if (len == null) {
      len = 5;
    }
    return Math.random().toString(35).substr(2, len);
  },
  longestCommonPrefix: function(strings, commonDelimiter) {
    var delimiterIndex, l, s1, s2;
    strings = strings.slice(0).sort();
    s1 = strings[0];
    l = s1.length;
    s2 = strings.pop();
    while (l && s2.indexOf(s1) === -1) {
      s1 = s1.substring(0, --l);
    }
    if (commonDelimiter && s2[s1.length] !== commonDelimiter) {
      delimiterIndex = s1.indexOf(commonDelimiter);
      s1 = s1.substring(0, delimiterIndex);
    }
    return s1;
  },
  detectRm5Encoding: function(file) {
    var detectingEncoding, reader;
    detectingEncoding = $.Deferred();
    reader = new FileReader();
    reader.onload = function(loadEvent) {
      var encoding;
      encoding = $.parseXML(loadEvent.target.result).xmlEncoding;
      return detectingEncoding.resolve(encoding);
    };
    reader.error = function(error) {
      return detectingEncoding.reject(error);
    };
    reader.readAsText(file);
    return detectingEncoding.promise();
  },
  isTraitEnabled: function(clazz, traitName) {
    var _ref;
    return __indexOf.call((_ref = clazz.traits) != null ? _ref : [], traitName) >= 0;
  },
  isWebkit: function() {
    return document.documentElement.style.hasOwnProperty('WebkitAppearance');
  },
  scrollbarWidth: function() {
    var child, parent, width;
    if (width === void 0) {
      parent = $('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body');
      child = parent.children();
      width = child.innerWidth() - child.height(99).innerWidth();
      parent.remove();
    }
    return width;
  },
  scrollTo: function(element, to, duration) {
    var animateScroll, change, currentTime, increment, start;
    start = element.scrollTop;
    change = to - start;
    currentTime = 0;
    increment = 20;
    animateScroll = function() {
      var val;
      currentTime += increment;
      val = utils.easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        return setTimeout(animateScroll, increment);
      }
    };
    return animateScroll();
  },
  easeInOutQuad: function(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t * t + b;
    }
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  },
  numberSort: function(a, b) {
    return a - b;
  },
  arrayMedian: function(arr) {
    var half;
    arr.sort(this.numberSort);
    half = Math.floor(arr.length / 2);
    if (arr.length % 2) {
      return arr[half];
    } else {
      return (arr[half - 1] + arr[half]) / 2.0;
    }
  },
  addToObjectWithMaxSize: function(obj, maxSize, keyValuePair, sortFn) {
    _(obj).extend(keyValuePair);
    if (_(obj).keys().length > maxSize) {
      return delete obj[_(obj).keys().sort(sortFn)[0]];
    }
  },
  parseFixedFloat: function(numberToParse, numberScale) {
    if (numberScale == null) {
      numberScale = 2;
    }
    return parseFloat(numberToParse).toFixed(numberScale);
  },
  isNumeric: function(obj) {
    return !jQuery.isArray(obj) && (obj - parseFloat(obj) + 1) >= 0;
  },
  millimetersToTwips: function(millimeters) {
    return Math.round(millimeters * 56.692913);
  },
  getKeyValObject: function(key, val) {
    var o;
    o = {};
    o[key] = val;
    return o;
  },
  deepCloneObject: function(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  removeNonPrintableChars: function(text) {
    var re;
    re = /[\x00-\x09\x0E-\x1F\x7F-\x9F\xAD\u0378\u0379\u037F-\u0383\u038B\u038D\u03A2\u0528-\u0530\u0557\u0558\u0560\u0588\u058B-\u058E\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08A1\u08AD-\u08E3\u08FF\u0978\u0980\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0C00\u0C04\u0C0D\u0C11\u0C29\u0C34\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5A-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C81\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D01\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5F\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F5-\u13FF\u169D-\u169F\u16F1-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191D-\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7-\u1CFF\u1DE7-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BB-\u20CF\u20F1-\u20FF\u218A-\u218F\u23F4-\u23FF\u2427-\u243F\u244B-\u245F\u2700\u2B4D-\u2B4F\u2B5A-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E3C-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FCD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA698-\uA69E\uA6F8-\uA6FF\uA78F\uA794-\uA79F\uA7AB-\uA7F7\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FC-\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9E0-\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAA7C-\uAA7F\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F-\uABBF\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE27-\uFE2F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]/g;
    return text.replace(re, '');
  },
  removeLineBreaks: function(str) {
    return str.replace(/(\r\n|\n|\r)/gm, ' ');
  },
  numberToSymbol: function(num) {
    var baseIndex, repeatCount;
    baseIndex = (num - 1) % FOOTNOTE_SYMBOLS.length;
    repeatCount = Math.ceil(num / FOOTNOTE_SYMBOLS.length);
    return FOOTNOTE_SYMBOLS[baseIndex].repeat(repeatCount);
  },
  numberToLetter: function(i) {
    var converted, digit, firstDigits, idx, inBase26, lastDigit, _i;
    inBase26 = (i - 1).toString(26);
    firstDigits = 2 <= inBase26.length ? __slice.call(inBase26, 0, _i = inBase26.length - 1) : (_i = 0, []), lastDigit = inBase26[_i++];
    converted = (function() {
      var _j, _len, _results;
      _results = [];
      for (idx = _j = 0, _len = firstDigits.length; _j < _len; idx = ++_j) {
        digit = firstDigits[idx];
        _results.push(String.fromCharCode(96 + parseInt(digit, 26)));
      }
      return _results;
    })();
    converted.push(String.fromCharCode(97 + parseInt(lastDigit, 26)));
    return converted.join('');
  }
}, numberToSymbol = function(num) {
  var base_index, repeat_count;
  base_index = (num - 1) % symbols.length;
  repeat_count = Math.ceil(num / symbols.length);
  return symbols[base_index].repeat(repeat_count);
}, {
  reportRavenError: function(error, options) {
    var _ref;
    if (options == null) {
      options = {};
    }
    if ((typeof Raven === "undefined" || Raven === null) && !((_ref = window.gdt) != null ? _ref.testMode : void 0)) {
      console.error(error);
    }
    if (_.isString(error)) {
      return typeof Raven !== "undefined" && Raven !== null ? Raven.captureMessage(error, options) : void 0;
    } else {
      return typeof Raven !== "undefined" && Raven !== null ? Raven.captureException(error, options) : void 0;
    }
  },
  getElementHeight: function(el) {
    var bb, bt, height, parseSize, pb, pt, styles;
    parseSize = function(size) {
      return parseInt(size != null ? size : 0);
    };
    styles = window.getComputedStyle(el);
    height = parseSize(styles.height);
    pt = parseSize(styles.paddingTop);
    pb = parseSize(styles.paddingBottom);
    bt = parseSize(styles.borderTop);
    bb = parseSize(styles.borderBottom);
    return height - pt - pb - bt - bb;
  },
  removeHTMLNode: function($el) {
    if ($el.remove != null) {
      return $el.remove();
    } else {
      return $el.removeNode(true);
    }
  },
  createPrintoutContainer: function() {
    var div;
    div = document.createElement('div');
    div.id = 'printout-container';
    div.style.position = 'absolute';
    div.style.visibility = 'hidden';
    div.style.top = '-10000px';
    div.style.left = '-10000px';
    div.style.width = '100%';
    return document.querySelector('#page-container').appendChild(div);
  },
  processStyleSheet: function($el, styleSheet) {
    var affectedEls, cssRule, sheetStylesStr, _i, _len, _ref;
    sheetStylesStr = '';
    _ref = styleSheet.cssRules;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      cssRule = _ref[_i];
      affectedEls = $el.querySelectorAll(cssRule.selectorText);
      if (_.isEmpty(affectedEls)) {
        continue;
      }
      sheetStylesStr += "" + cssRule.cssText + "\n";
    }
    return sheetStylesStr;
  },
  getElementAppliedStylesString: function($targetEl) {
    var $targetParent, resultingStyleString, styleSheet, _i, _len, _ref;
    $targetParent = $targetEl.parentElement;
    if (!$targetParent) {
      return '';
    }
    resultingStyleString = '';
    _ref = document.styleSheets;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      styleSheet = _ref[_i];
      resultingStyleString += utils.processStyleSheet($targetParent, styleSheet);
    }
    return resultingStyleString;
  },
  getQueryParam: function(paramName) {
    var result;
    result = null;
    location.search.substr(1).split("&").forEach(function(item) {
      var tmp;
      tmp = item.split('=');
      if (tmp[0] === paramName) {
        return result = decodeURIComponent(tmp[1]);
      }
    });
    return result;
  },
  setQueryParam: function(paramName, paramValue) {
    var re, searchLoc, _ref;
    searchLoc = (_ref = window.location.search) != null ? _ref : '';
    re = new RegExp("([&?]" + paramName + "=)[^&]+");
    return window.location.search = searchLoc.length ? re.test(searchLoc) ? searchLoc.replace(re, "$1" + paramValue) : searchLoc += "&" + paramName + "=" + paramValue : searchLoc += "" + paramName + "=" + paramValue;
  },
  getCurrentLanguage: function() {
    return i18next.language;
  },
  isSafari: function() {
    return !!window.navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  },
  objectsEqual: objectsEqual,
  sanitizeHTML: sanitizeHTML,
  getFileExtension: function(fileName) {
    var split;
    split = fileName.split('.');
    if (split.length > 1) {
      return _.last(split);
    } else {
      return '';
    }
  },
  formatFileSize: function(size) {
    if (size < 1000) {
      return "" + size + " B";
    } else if (size < 1000 * 1000) {
      return "" + (Math.round(size / 1000)) + " KB";
    } else {
      return "" + (Math.round((size / (1000 * 1000)) * 100) / 100) + " MB";
    }
  },
  isInstanceOf: R.curry(function(parent, child) {
    return child instanceof parent;
  }),
  invariant: R.curry(function(invariantCheck, successAction, failAction) {
    return R.cond([[invariantCheck, successAction], [R.T, failAction]]);
  }),
  callMethod: function() {
    var args, methodName;
    methodName = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    return function(object) {
      var method;
      method = object[methodName];
      if (_.isFunction(method)) {
        return method.apply(object, args);
      } else {
        throw new Error("callMethod error: provided object doesn't have method `" + methodName + "`.");
      }
    };
  },
  groupByKeepOrder: function(arr, prop) {
    var newArr, wrapObj;
    newArr = [];
    wrapObj = {};
    _.forEach(arr, function(item) {
      var propName;
      propName = item[prop];
      if (propName) {
        propName = propName.toString();
        if (!wrapObj[propName]) {
          wrapObj[propName] = [];
          newArr.push(wrapObj[propName]);
        }
        return wrapObj[propName].push(item);
      }
    });
    return newArr;
  }
});

module.exports = utils;

_curryN = function(length, combinedArgs, fn) {
  return function() {
    var args, current;
    args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
    current = combinedArgs.concat(args);
    if (current.length >= length) {
      return fn.apply(this, current);
    } else {
      return _curryN(length, current, fn);
    }
  };
};

_.prototype.runEvery = function(ms) {
  return {
    interval: setInterval(this._wrapped, ms),
    "for": function(ms) {
      return setTimeout(((function(_this) {
        return function() {
          return clearInterval(_this.interval);
        };
      })(this)), ms);
    }
  };
};

_.functionName = function(f) {
  var _ref;
  return (_ref = f.name) != null ? _ref : f.toString().match(/function\s+([^( ]+)/)[1];
};

_.fill = function(arr, val) {
  return arr.map(function(el) {
    return val;
  });
};

_["instanceof"] = function(obj, instances) {
  var instance, _i, _len;
  for (_i = 0, _len = instances.length; _i < _len; _i++) {
    instance = instances[_i];
    if (obj instanceof instance) {
      return true;
    }
  }
  return false;
};

_.indexObjectsArray = function(array, indexKey) {
  var idx;
  if (indexKey == null) {
    indexKey = 'index';
  }
  idx = -1;
  return _(array).map(function(obj) {
    obj[indexKey] = ++idx;
    return obj;
  });
};

_.partition = function(array, partitionFn) {
  return _(array).reduce(function(_arg, el) {
    var inArr, outArr, targetArr;
    inArr = _arg[0], outArr = _arg[1];
    targetArr = partitionFn(el) ? inArr : outArr;
    targetArr.push(el);
    return [inArr, outArr];
  }, [[], []]);
};

_.namespace = function(module, body) {
  var bindFunctions, _ref;
  bindFunctions = function(exposePrivate) {
    return function(require) {
      var fn, name, ns, publicFns, _ref;
      publicFns = {};
      ns = {};
      _ref = body.call(ns, require);
      for (name in _ref) {
        fn = _ref[name];
        ns[name] = fn.bind(ns);
        if (name[0] !== '_') {
          publicFns[name] = ns[name];
        }
      }
      if (exposePrivate) {
        return ns;
      } else {
        return publicFns;
      }
    };
  };
  return module.exports = ((_ref = window.gdt) != null ? _ref.testMode : void 0) ? bindFunctions(true) : bindFunctions(false)(require);
};

_.curry = function(fn) {
  return _curryN(fn.length, [], fn);
};

_.constant = function(v) {
  return function() {
    return v;
  };
};

$.fn.forceRedraw = function() {
  var el, previousDisplay;
  el = this[0];
  previousDisplay = el.style.display;
  el.style.display = 'none';
  el.offsetHeight;
  return el.style.display = previousDisplay;
};
